export const ACTIVITY_TYPES = {
  WHATSAPP_MESSAGE: 'whatsapp_message',
  INSTAGRAM_MESSAGE: 'instagram_message',
  FACEBOOK_MESSAGE: 'facebook_message',
  EMAIL: 'email',
  PHONE_CALL: 'phone_call',
  MEETING: 'meeting',
  IN_PERSON_VISIT: 'in_person_visit',
  VOICE_NOTE: 'voice_note',
  PROPOSAL_SENT: 'proposal_sent',
  FOLLOW_UP: 'follow_up',
  RESPONSE_RECEIVED: 'response_received',
  STATUS_CHANGE: 'status_change',
  INTERNAL_NOTE: 'internal_note',
  OTHER: 'other',
} as const

export type ActivityType = (typeof ACTIVITY_TYPES)[keyof typeof ACTIVITY_TYPES]

export const ACTIVITY_TYPE_OPTIONS = Object.values(
  ACTIVITY_TYPES,
) as ActivityType[]

export const ACTIVITY_TYPE_LABELS: Record<ActivityType, string> = {
  [ACTIVITY_TYPES.WHATSAPP_MESSAGE]: 'Mensaje por WhatsApp',
  [ACTIVITY_TYPES.INSTAGRAM_MESSAGE]: 'Mensaje por Instagram',
  [ACTIVITY_TYPES.FACEBOOK_MESSAGE]: 'Mensaje por Facebook',
  [ACTIVITY_TYPES.EMAIL]: 'Correo electrónico',
  [ACTIVITY_TYPES.PHONE_CALL]: 'Llamada telefónica',
  [ACTIVITY_TYPES.MEETING]: 'Reunión',
  [ACTIVITY_TYPES.IN_PERSON_VISIT]: 'Visita presencial',
  [ACTIVITY_TYPES.VOICE_NOTE]: 'Nota de voz',
  [ACTIVITY_TYPES.PROPOSAL_SENT]: 'Propuesta enviada',
  [ACTIVITY_TYPES.FOLLOW_UP]: 'Seguimiento',
  [ACTIVITY_TYPES.RESPONSE_RECEIVED]: 'Respuesta recibida',
  [ACTIVITY_TYPES.STATUS_CHANGE]: 'Cambio de estado',
  [ACTIVITY_TYPES.INTERNAL_NOTE]: 'Nota interna',
  [ACTIVITY_TYPES.OTHER]: 'Otra actividad',
}

export const ActivityTypeByChannel = {
  whatsapp: ACTIVITY_TYPES.WHATSAPP_MESSAGE,
  instagram: ACTIVITY_TYPES.INSTAGRAM_MESSAGE,
  facebook: ACTIVITY_TYPES.FACEBOOK_MESSAGE,
  email: ACTIVITY_TYPES.EMAIL,
} as const

export type ActivityMessageChannel = keyof typeof ActivityTypeByChannel

export function isActivityType(value: unknown): value is ActivityType {
  return (
    typeof value === 'string' &&
    ACTIVITY_TYPE_OPTIONS.includes(value as ActivityType)
  )
}

export function isActivityMessageChannel(
  value: unknown,
): value is ActivityMessageChannel {
  return typeof value === 'string' && value in ActivityTypeByChannel
}

export function getActivityTypeForChannel(
  channel: unknown,
): ActivityType | null {
  return isActivityMessageChannel(channel)
    ? ActivityTypeByChannel[channel]
    : null
}

export function activityTypeLabel(value: unknown): string {
  return isActivityType(value) ? ACTIVITY_TYPE_LABELS[value] : 'Actividad'
}
